//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressIcon from 'assets/icons/icon-address@3x.png'
import timeIcon from 'assets/icons/icon-time@3x.png'
import routeHelper from '../../../utils/route-helper.js'
import QiniuImg from '../../Common/QiniuImg.vue'
import { mapActions } from 'vuex'

export default {
  name: 'MatchCard',
  props: {
    match: {
      type: Object,
      required: true,
    },
    showLeagueName: {
      type: Boolean,
      default: false,
    },
    isOversea: false,
    isCtcSell: false, // 是否C2C转票
  },
  components: {
    QiniuImg,
  },
  computed: {
    matchStatus() {
      const saleStatus = {
        1: 'not-open',
        2: 'on-sale',
        3: 'presale',
        4: 'closed',
        5: 'sold-out',
        6: 'purchasing',
      }
      return saleStatus[this.match.saleStatus]
    },
    matchStatusText() {
      const saleStatus = {
        1: '未开售',
        2: '售票中',
        3: '预售',
        4: '已停售',
        5: '售罄',
        6: '代购中',
      }
      return saleStatus[this.match.saleStatus]
    },
  },
  methods: {
    ...mapActions(['showToast']),
    getFeatureStyle(featureStyleType) {
      const featureStyleList = ['feature-green-1', 'feature-green-2', 'feature-grey-1', 'feature-grey-2', 'feature-orange-1', 'feature-orange-2', 'feature-grass-green-1', 'feature-grass-green-2']
      return featureStyleType <= featureStyleList.length ?
       featureStyleList[featureStyleType - 1] : featureStyleList[0]
    },
    toMatchDetail() {
      if (this.isOversea) {
        this.$router.push({ name: 'ctc-match-ticket', params: { matchId: this.match.id } })
      } else if (this.isCtcSell) {
        this.checkToCtcSell()
      } else {
        this.$router.push({ name: 'ctc-match-ticket', params: { matchId: this.match.id } })
      }
    },
    checkToCtcSell() {
      if (this.$jwt.userId) {
        this.$http.get(`/api/ctcOrder/sellInit/${this.match.id}`).then(res => res.json()).then((data) => {
          if (data.type === 1) {
            this.toCtcSell()
          } else if (data.type === 2) {
            // this.showToast({
            //   content: '请先在App中提交卖家验证',
            // })
            this.$router.push({
              name: 'ctc-seller-auth',
            })
          } else if (data.type === 3) {
            this.showToast({
              content: data.interruptMsg,
            })
          }
        }).catch((err) => {
          this.showToast({
            content: err.body.resultInfo,
          })
        })
      } else {
        this.showToast({ content: '请先登录' })
        routeHelper.redirectToLogin(this.$router, this.$route.path)
      }
    },
    toCtcSell() {
      this.$router.push({ name: 'ctc-order-sell', params: { matchId: this.match.id } })
    },
  },
  data() {
    return {
      addressIcon,
      timeIcon,
    }
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/MatchCard.vue